import React from 'react';

import { Payments } from '~/screens/ContractDetails/Panels/Payments/Payments';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractInstallmentsViewProps = {
  contractId: string;
  onBack: () => void;
};

export function ContractInstallmentsView({ contractId, onBack }: ContractInstallmentsViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <Payments contractId={contractId} />
    </div>
  );
}
